import { alpha, ButtonBase, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	children: ReactNode;
	onClick?: () => void;
	type?: "button" | "submit" | "reset";
	disabled?: boolean;
};

export const FormSubmitButton: FC<Props> = ({
	children,
	onClick,
	type = "submit",
	disabled,
}) => {
	const theme = useTheme();

	return (
		<ButtonBase
			type={type}
			onClick={onClick}
			disabled={disabled}
			sx={{
				width: "100%",
				py: 1.75,
				fontWeight: 600,
				fontSize: 16,
				borderRadius: "16px",
				color: disabled ? theme.palette.grey[400] : theme.palette.common.white,
				bgcolor: theme.palette.primary.main,
				boxShadow: disabled
					? "none"
					: `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
				cursor: disabled ? "not-allowed" : "pointer",
				transition: "transform 120ms ease-out",
				"&:active": disabled ? undefined : { transform: "scale(0.97)" },
				"&.Mui-disabled": {
					color: theme.palette.grey[400],
					bgcolor: theme.palette.grey[100],
				},
			}}
		>
			{children}
		</ButtonBase>
	);
};
